/* eslint-disable jsx-a11y/media-has-caption */
/* eslint-disable react/forbid-prop-types */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import { FiExternalLink, FiPlay, FiVideo, FiX } from 'react-icons/fi';
import PackageImage from '../common/PackageImage';

/**
 * Video tiles. YouTube / Vimeo play in a popup through the providers' own
 * players; a direct video file plays in <video>; any other link opens in a
 * new tab. videos: the shape from packageVideos().
 */
function PackageVideos({ videos }) {
  const [playing, setPlaying] = useState(null);
  const titleOf = (v, i) => v.title || `Video ${i + 1}`;

  return (
    <>
      <div className="pkg-videos">
        {videos.map((v, i) => {
          const tile = (
            <>
              {v.thumbnail ? (
                <PackageImage src={v.thumbnail} />
              ) : (
                <span className="pkg-videos__blank" aria-hidden>
                  <FiVideo size={28} />
                </span>
              )}
              <span className="pkg-videos__play" aria-hidden>
                {v.kind === 'link' ? <FiExternalLink /> : <FiPlay />}
              </span>
              {v.title && <span className="pkg-videos__title">{v.title}</span>}
            </>
          );
          return v.kind === 'link' ? (
            <a
              key={v.key}
              className="pkg-videos__tile"
              href={v.url}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={`Open ${titleOf(v, i)}`}
            >
              {tile}
            </a>
          ) : (
            <button
              type="button"
              key={v.key}
              className="pkg-videos__tile"
              onClick={() => setPlaying({ ...v, label: titleOf(v, i) })}
              aria-label={`Play ${titleOf(v, i)}`}
            >
              {tile}
            </button>
          );
        })}
      </div>

      <Modal
        show={Boolean(playing)}
        onHide={() => setPlaying(null)}
        size="xl"
        centered
        dialogClassName="pkg-modal"
      >
        <Modal.Body>
          <button
            type="button"
            className="pkg-modal__close"
            onClick={() => setPlaying(null)}
            aria-label="Close"
          >
            <FiX />
          </button>
          <h3 className="pkg-modal__title">{playing?.label}</h3>
          {playing && (
            <div className="pkg-videos__player">
              {playing.kind === 'file' ? (
                <video src={playing.url} controls autoPlay playsInline />
              ) : (
                <iframe
                  src={playing.embedUrl}
                  title={playing.label}
                  allow="autoplay; encrypted-media; picture-in-picture; fullscreen"
                  allowFullScreen
                  referrerPolicy="strict-origin-when-cross-origin"
                />
              )}
            </div>
          )}
        </Modal.Body>
      </Modal>
    </>
  );
}

PackageVideos.propTypes = {
  videos: PropTypes.array.isRequired,
};

export default PackageVideos;
